/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/OrganizationItemLightPaginationSlice', 'model/MarketSearchTemplateReport', 'model/OrganizationPaginationSlice', 'model/FinancialsAndDecisionMakers', 'model/OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/OrganizationItemLightPaginationSlice'), require('../model/MarketSearchTemplateReport'), require('../model/OrganizationPaginationSlice'), require('../model/FinancialsAndDecisionMakers'), require('../model/OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.OrganizationApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.OrganizationItemLightPaginationSlice, root.ForStractionServiceApi.MarketSearchTemplateReport, root.ForStractionServiceApi.OrganizationPaginationSlice, root.ForStractionServiceApi.FinancialsAndDecisionMakers, root.ForStractionServiceApi.OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport);
  }
}(this, function(ApiClient, OrganizationItemLightPaginationSlice, MarketSearchTemplateReport, OrganizationPaginationSlice, FinancialsAndDecisionMakers, OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport) {
  'use strict';

  /**
   * Organization service.
   * @module api/OrganizationApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new OrganizationApi. 
   * @alias module:api/OrganizationApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the organizationAutocompleteNameGet operation.
     * @callback module:api/OrganizationApi~organizationAutocompleteNameGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrganizationItemLightPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * autocompleteName
     * @param {String} _4SAPIAppID 
     * @param {String} searchValue 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {module:api/OrganizationApi~organizationAutocompleteNameGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrganizationItemLightPaginationSlice}
     */
    this.organizationAutocompleteNameGet = function(_4SAPIAppID, searchValue, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling organizationAutocompleteNameGet";
      }

      // verify the required parameter 'searchValue' is set
      if (searchValue == undefined || searchValue == null) {
        throw "Missing the required parameter 'searchValue' when calling organizationAutocompleteNameGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'searchValue': searchValue,
        'startID': opts['startID'],
        'maxCount': opts['maxCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = OrganizationItemLightPaginationSlice;

      return this.apiClient.callApi(
        '/Organization/autocompleteName', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the organizationEstimateTotalForKeywordSearchListPut operation.
     * @callback module:api/OrganizationApi~organizationEstimateTotalForKeywordSearchListPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * estimateTotalForKeywordSearchList
     * @param {String} _4SAPIAppID 
     * @param {module:model/MarketSearchTemplateReport} body 
     * @param {module:api/OrganizationApi~organizationEstimateTotalForKeywordSearchListPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.organizationEstimateTotalForKeywordSearchListPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling organizationEstimateTotalForKeywordSearchListPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling organizationEstimateTotalForKeywordSearchListPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/Organization/estimateTotalForKeywordSearchList', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the organizationExtendedSearchGet operation.
     * @callback module:api/OrganizationApi~organizationExtendedSearchGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrganizationPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * extendedSearch
     * @param {String} _4SAPIAppID 
     * @param {Object} opts Optional parameters
     * @param {String} opts.name  (default to )
     * @param {Integer} opts.classificationID  (default to 0)
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.keywordTemplateID  (default to 0)
     * @param {module:api/OrganizationApi~organizationExtendedSearchGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrganizationPaginationSlice}
     */
    this.organizationExtendedSearchGet = function(_4SAPIAppID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling organizationExtendedSearchGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'name': opts['name'],
        'classificationID': opts['classificationID'],
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'keywordTemplateID': opts['keywordTemplateID']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = OrganizationPaginationSlice;

      return this.apiClient.callApi(
        '/Organization/extendedSearch', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the organizationGetFinancialInformationGet operation.
     * @callback module:api/OrganizationApi~organizationGetFinancialInformationGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FinancialsAndDecisionMakers} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * getFinancialInformation
     * @param {String} _4SAPIAppID 
     * @param {String} finnishBusinessIdentifier 
     * @param {Boolean} buyIfMissing 
     * @param {module:api/OrganizationApi~organizationGetFinancialInformationGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FinancialsAndDecisionMakers}
     */
    this.organizationGetFinancialInformationGet = function(_4SAPIAppID, finnishBusinessIdentifier, buyIfMissing, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling organizationGetFinancialInformationGet";
      }

      // verify the required parameter 'finnishBusinessIdentifier' is set
      if (finnishBusinessIdentifier == undefined || finnishBusinessIdentifier == null) {
        throw "Missing the required parameter 'finnishBusinessIdentifier' when calling organizationGetFinancialInformationGet";
      }

      // verify the required parameter 'buyIfMissing' is set
      if (buyIfMissing == undefined || buyIfMissing == null) {
        throw "Missing the required parameter 'buyIfMissing' when calling organizationGetFinancialInformationGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'finnishBusinessIdentifier': finnishBusinessIdentifier,
        'buyIfMissing': buyIfMissing
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = FinancialsAndDecisionMakers;

      return this.apiClient.callApi(
        '/Organization/getFinancialInformation', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the organizationGetLatestRegistrationDateGet operation.
     * @callback module:api/OrganizationApi~organizationGetLatestRegistrationDateGetCallback
     * @param {String} error Error message, if any.
     * @param {'Date'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * getLatestRegistrationDate
     * @param {String} _4SAPIAppID 
     * @param {module:api/OrganizationApi~organizationGetLatestRegistrationDateGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Date'}
     */
    this.organizationGetLatestRegistrationDateGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling organizationGetLatestRegistrationDateGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Date';

      return this.apiClient.callApi(
        '/Organization/getLatestRegistrationDate', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the organizationSearchInIndexByKeywordGet operation.
     * @callback module:api/OrganizationApi~organizationSearchInIndexByKeywordGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchInIndexByKeyword
     * @param {String} _4SAPIAppID 
     * @param {String} query 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.pageNumber  (default to 0)
     * @param {Integer} opts.pageSize  (default to 0)
     * @param {Boolean} opts.shouldDocumentsBeClustered  (default to false)
     * @param {String} opts.sort  (default to )
     * @param {module:api/OrganizationApi~organizationSearchInIndexByKeywordGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport}
     */
    this.organizationSearchInIndexByKeywordGet = function(_4SAPIAppID, query, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling organizationSearchInIndexByKeywordGet";
      }

      // verify the required parameter 'query' is set
      if (query == undefined || query == null) {
        throw "Missing the required parameter 'query' when calling organizationSearchInIndexByKeywordGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'query': query,
        'pageNumber': opts['pageNumber'],
        'pageSize': opts['pageSize'],
        'shouldDocumentsBeClustered': opts['shouldDocumentsBeClustered'],
        'sort': opts['sort']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport;

      return this.apiClient.callApi(
        '/Organization/searchInIndexByKeyword', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
